import { SCREENS, REDUX_ACTIONS, GAME_ID } from '../../data/planTorresConstants';

const initialState = {
  currentScreen: SCREENS.LOADING,
  previousScreen: null,
};

const planTorresScreenReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        currentScreen: payload,
        previousScreen: state.currentScreen,
      };
    default:
      return state;
  }
};

export default planTorresScreenReducer;
